var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGotoLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "icons8_external_link_16px",
    width: 25,
    height: 25,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAABHklEQVQ4EcVRO04DQQx9XnIKJJSdQyShQDShCwJR7iCFDnEDOAK0FOkQFPmIW9BA2EhcAWWF0nGGMXaSHQ3DbkSX0Vh+9vOz7Blg24f+M8B83OG4LrX5UpvERFWsxWoAd4X/FvO3UaJi2D7mHboHw5Q59Ux8Z7LZzZIHPYKSU7B7VU7NN0BCAwb1jX1/QXTmk3aPeSVOs+mbrOQr/Aqy5J7J/oqL0f4RmB5k/BMVe+Ua+Abr+JdTsawwFPFZamdTia+1YPUeioDaBsWk1RXxEzF6KtZyiW/Vh1bbwHHSd+xs8zz/CAUxbsSJMjY2vyjxJl87wSZRyIUNFsW4cxCSIf4ctQ4J+Apziv0K5PiKE3qWP95VosIWzLisyG859QMJI12Z2w7xjAAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotoLink);
export default __webpack_public_path__ + "static/media/gotoLink.7a5de1c08f70e5389ba0203b649a4ece.svg";
export { ForwardRef as ReactComponent };